const CART_REVIEWS_INTERVAL = 6000;

class CartReviews extends HTMLElement {

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-js-review]'));
    this.dots = Array.from(this.querySelectorAll('[data-js-review-dot]'));
    if (this.slides.length < 2) return;

    this.index = 0;

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.show(i);
        this.stop();
      });
    });

    // Once the shopper takes over, stop rotating out from under them.
    this.querySelectorAll('[data-js-review-prev]').forEach(button => {
      button.addEventListener('click', () => {
        this.step(-1);
        this.stop();
      });
    });

    this.querySelectorAll('[data-js-review-next]').forEach(button => {
      button.addEventListener('click', () => {
        this.step(1);
        this.stop();
      });
    });

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.hasAttribute('data-autoplay') && !reducedMotion) {
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('focusin', () => this.stop());
      this.start();
    }
  }

  disconnectedCallback() {
    // Cart updates replace #AjaxCartSubtotal via innerHTML, discarding this element.
    // Without this, every cart change would leak another running interval.
    this.stop();
  }

  show(index) {
    this.index = index;
    this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
  }

  step(delta) {
    const count = this.slides.length;
    this.show((this.index + delta + count) % count);
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.step(1), CART_REVIEWS_INTERVAL);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

customElements.define('cart-reviews', CartReviews);
